var _path, _path2, _path3, _rect, _path4, _path5, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 360,
    viewBox: "0 0 364 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333 190L155 142V360H333V190Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98L205 58V360H31V98Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 360H205V155.483L155 142V360Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 236,
    width: 44,
    height: 92,
    transform: "rotate(-90 63 236)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 360L63 306C63 289.431 76.4315 276 93 276V276C109.569 276 123 289.431 123 306L123 360L63 360Z",
    fill: "#E7E7E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205 320L205 276L301 276L301 320L205 320Z",
    fill: "#304FF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 320,
    width: 44,
    height: 50,
    transform: "rotate(-90 155 320)",
    fill: "#304FF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 236,
    width: 44,
    height: 50,
    transform: "rotate(-90 155 236)",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.058f89c80b4af4f2b8550fd67dd4142f.svg";
export { ForwardRef as ReactComponent };